"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const THREE = __importStar(require("three"));
const Chapter_1 = __importDefault(require("./Chapter"));
const Paper_1 = __importDefault(require("../three/element/Paper"));
const Util_1 = __importDefault(require("../Util"));
const Text_1 = __importDefault(require("../three/element/Text"));
class ChapterConfetti extends Chapter_1.default {
    constructor(stage, text, key) {
        super();
        this.text = text;
        this.key = key;
        this.stage = stage;
        this.papers = [];
        this.container = null;
        this.firstPaper = null;
        this.txtKo = null;
    }
    start() {
        this.stage.renderer.setClearColor(0x000000, 1);
        this.stage.scene.fog = new THREE.Fog(0x000000, 2, 10);
        this.stage.grid.setWhite();
        this.stage.camera.position.set(0, 0, 4);
        this.stage.controls.target.set(0, 0, 0);
        this.stage.controls.update();
        this.stage.fixCameraBasePos();
        this.container = new THREE.Object3D();
        this.stage.add(this.container);
        this.firstPaper = new Paper_1.default(0.3, 0.3);
        this.firstPaper.setUniforms('u_amplitude', 0.1);
        this.firstPaper.setUniforms('u_frequency', 5);
        this.firstPaper.setGap(0.01);
        this.firstPaper.position.set(-4, -4, 0);
        this.firstPaper.rotation.set(0, Math.random() * 0.4 + 0.4, -0.2);
        this.container.add(this.firstPaper);
        this.txtKo = new Text_1.default(1.2, 0.3, this.stage.cache.get('textConfetti'));
        this.txtKo.position.set(0, -0.4, -0.3);
        this.stage.add(this.txtKo);
        this._createPapers();
        this._animate(() => {
            this.done(0.5);
        });
        this.dispatchTextWhite();
    }
    update() {
        var _a;
        (_a = this.firstPaper) === null || _a === void 0 ? void 0 : _a.update();
        this.papers.forEach(paper => paper.update());
    }
    stop(cb) {
        if (this.firstPaper) {
            gsap_1.gsap.to(this.firstPaper.position, {
                duration: 3,
                x: 3,
                y: 3,
                ease: 'power1.inOut',
            });
        }
        gsap_1.gsap.delayedCall(1, () => {
            this.papers.forEach(paper => {
                gsap_1.gsap.to(paper.position, {
                    duration: Util_1.default.random(3, 8),
                    x: Util_1.default.random(2, 8),
                    y: Util_1.default.random(3, 8),
                });
            });
        });
        gsap_1.gsap.delayedCall(2, () => { var _a; return (_a = this.txtKo) === null || _a === void 0 ? void 0 : _a.fadeOut(1); });
        gsap_1.gsap.delayedCall(7.5, () => {
            this.papers.forEach(paper => gsap_1.gsap.killTweensOf(paper.position));
            if (this.container)
                this.stage.remove(this.container);
            if (this.txtKo)
                this.stage.remove(this.txtKo);
            this.papers = [];
            this.container = null;
            this.firstPaper = null;
            this.txtKo = null;
            cb();
        });
    }
    _createPapers() {
        var _a;
        for (let i = 0; i < 200; i++) {
            const width = Number(Util_1.default.random(0.1, 0.3).toFixed(1));
            const paper = new Paper_1.default(width, width);
            paper.setFog(this.stage.scene.fog);
            paper.rotation.z = Util_1.default.random(-0.6, 0.1);
            paper.rotation.y = Util_1.default.random(0.4, 0.8);
            const x = Util_1.default.random(-9, -6);
            const y = Util_1.default.random(-9, -6);
            const z = Util_1.default.random(-2, 2);
            paper.position.set(x, y, z);
            (_a = this.container) === null || _a === void 0 ? void 0 : _a.add(paper);
            this.papers.push(paper);
        }
    }
    _animate(cb) {
        if (this.firstPaper) {
            gsap_1.gsap.to(this.firstPaper.position, {
                duration: 5,
                x: 0,
                y: 0,
                ease: 'circ.out',
                onComplete: () => {
                    cb();
                },
            });
        }
        gsap_1.gsap.delayedCall(3, () => {
            var _a;
            (_a = this.txtKo) === null || _a === void 0 ? void 0 : _a.fadeIn(2);
            this.showText(0, 'white');
        });
    }
}
exports.default = ChapterConfetti;
